define('v3/Common/Components/TimePeriodDropdown/TimePeriodDropdown.Component',[
	'knockout',
	'lodash',
	'v3/Common/Models/enums',
	'text!v3/Common/Components/TimePeriodDropdown/TimePeriodDropdown.Component.html',
	'v3/Common/Components/Dropdown/Dropdown.Component'
], function (ko, _, enums, htmlString) {
	function validateParams (params) {
		if (!ko.isWriteableObservable(params.value)) {
			throw new Error('Please provide params.value as a writable observable.');
		}
	}

	function getSemesterPeriods (date) {
		var periods = [{ period: enums.semesterPeriod.year, name: Strings.SecondSemester_Year }];

		date || (date = new Date());

		if (date.getMonth() >= 0 && date.getMonth() <= 6) {
			periods.push(
				{ period: enums.semesterPeriod.firstSemester, name: Strings.SecondSemester_FirstSemester },
				{ period: enums.semesterPeriod.secondSemester, name: Strings.SecondSemester_SecondSemester }
			);
		}

		return periods;
	}

	function TimePeriodDropdownViewModel (params) {
		var self = this;

		validateParams(params);

		self.disabled = params.disabled || false;

		self.periods = getSemesterPeriods();
		self.selectedPeriod = ko.observable(params.value());

		self.selectedPeriod.subscribe(function (period) {
			params.value(period);
		});
	}

	return { viewModel: TimePeriodDropdownViewModel, template: htmlString };
});
